import { EKocCategory } from "@/modules/helpers/enum"

type VideoCategory = {
  value: EKocCategory
  title: string
  description: string
}

export const categories: VideoCategory[] = [
  {
    value: EKocCategory.UNBOXING,
    title: "Unboxing",
    description:
      "Quay cảnh mở gói hàng, bao bì của sản phẩm, nêu cảm nhận ban đầu về sản phẩm (bao bì, thành phần, mùi hương,...). KHÔNG SHOW MẶT"
  },
  {
    value: EKocCategory.REVIEW,
    title: "Review trải nghiệm/ Show mặt",
    description:
      "Có thể quay cảnh sử dụng sản phẩm trong tình huống thực tế (dùng sản phẩm lên da, mặc sản phẩm,...) chia sẻ cảm nhận trực tiếp về sản phẩm, bao gồm cảnh trước - sau (nếu có) ví dụ: da trước - sau khi dùng kem."
  },
  {
    value: EKocCategory.GET_READY_WITH_ME,
    title: "Get ready/Unready with me",
    description:
      "Quay cảnh chuẩn bị (trang điểm, dưỡng da, mặc đồ) hoặc tháo gỡ (tẩy trang, chăm sóc da). Lồng ghép sản phẩm tự nhiên, tạo cảm giác gần gũi."
  },
  {
    value: EKocCategory.SHOW_FULL_BODY,
    title: "Show toàn thân",
    description: "Video quay toàn thân"
  },
  {
    value: EKocCategory.DUPE_OR_BETTER,
    title: "Dupe or Better",
    description:
      "So sánh sản phẩm của brand với sản phẩm nổi tiếng/đắt tiền, nhấn mạnh chất lượng tương đương hoặc tốt hơn với giá rẻ hơn."
  },
  {
    value: EKocCategory.DAY_IN_THE_LIFE,
    title: "Day in the Life/ Mini vlog",
    description:
      "Quay một ngày bình thường hoặc vlog đi chơi/ đi học/ đi làm,...; lồng ghép sản phẩm vào các hoạt động một cách tự nhiên."
  },
  {
    value: EKocCategory.TUTORIAL,
    title: "Hướng dẫn sử dụng (Tutorial)",
    description:
      "Hướng dẫn cách dùng sản phẩm đơn giản, dễ hiểu. Cho thấy được sản phẩm có thể sử dụng một cách dễ dàng và có tác dụng như thế nào"
  }
]
